unable to read source [project]/packages/src/components/base/layout/box/Box.tsx